import { render, staticRenderFns } from "./KPI.vue?vue&type=template&id=e33e8e82&scoped=true"
import script from "./KPI.vue?vue&type=script&lang=ts"
export * from "./KPI.vue?vue&type=script&lang=ts"
import style0 from "./KPI.scss?vue&type=style&index=0&id=e33e8e82&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33e8e82",
  null
  
)

export default component.exports